import {Component, Input} from '@angular/core';
import {FormGroup} from '@angular/forms';
import {PaymentProviderResponse, PaymentReceipt} from '@gatewee/types/payment';
import {
  formatRecipientAccount,
  formatRecipientAgency,
} from '../withdrawal-pix-recipient.utils';

@Component({
  selector: 'app-withdrawal-step-payment-proof',
  templateUrl: './withdrawal-step-payment-proof.component.html',
  standalone: false,
})
export class WithdrawalStepPaymentProofComponent {
  @Input() form!: FormGroup;
  @Input() confirmedBankDisplayLine = '';
  @Input() resolvedRecipientName = '';
  @Input() isWithdrawalPolling = false;
  @Input() isWithdrawalSuccess = false;
  @Input() isWithdrawalFailed = false;
  @Input() statusErrorMessage: string | null = null;
  @Input() paymentReceipt?: PaymentReceipt;
  @Input() paymentMetadata?: PaymentProviderResponse<unknown, unknown>;
  @Input() amount: number | null = null;
  @Input() calculatedFee: number | null = null;
  @Input() finalAmount: number | null = null;

  formatAgency = formatRecipientAgency;
  formatAccount = formatRecipientAccount;
}
